class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    this.key = 'panelpartners:recently-viewed';
    this.limit = parseInt(this.dataset.limit, 10) || 4;
    this.grid = this.querySelector('[data-grid]');
    if (!this.grid) return;

    let list = this.read();

    // Record the current product (only present on product pages).
    // Match on product id, not handle: the handle changes when the merchant
    // edits a product URL, which left the same product in the list once per
    // old URL. Entries saved before ids were stored still match on handle.
    const current = this.dataset.currentHandle;
    const currentId = this.dataset.currentId;
    const isCurrent = (p) => (currentId && p.id === currentId) || p.handle === current;
    if (current) {
      list = list.filter((p) => !isCurrent(p));
      list.unshift({
        id: currentId,
        handle: current,
        title: this.dataset.currentTitle,
        url: this.dataset.currentUrl,
        price: this.dataset.currentPrice,
        image: this.dataset.currentImage,
      });
      list = list.slice(0, 20);
      this.write(list);
    }

    const items = list.filter((p) => !isCurrent(p)).slice(0, this.limit);
    if (!items.length) return;

    this.grid.innerHTML = items.map((p) => this.card(p)).join('');
    this.grid.hidden = false;
    this.hidden = false;
  }

  read() {
    try {
      return JSON.parse(localStorage.getItem(this.key)) || [];
    } catch (e) {
      return [];
    }
  }

  write(list) {
    try {
      localStorage.setItem(this.key, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — ignore */
    }
  }

  card(p) {
    const image = p.image
      ? `<img src="${encodeURI(p.image)}" alt="" loading="lazy">`
      : '';
    return `<a class="recently-viewed__card" href="${encodeURI(p.url || '#')}">
      <span class="recently-viewed__image">${image}</span>
      <span class="recently-viewed__title">${this.esc(p.title)}</span>
      <span class="recently-viewed__price">${this.esc(p.price)}</span>
    </a>`;
  }

  esc(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }
}

customElements.define('recently-viewed', RecentlyViewed);
